const SITE_TITLE = 'Visiome Platform';
const SITE_SLOGAN = 'Digital archive for vision science';
// Replaces the Universal Analytics property (UA-2787276-1), shut down in 2023.
const GOOGLE_ANALYTICS_TRACKING_ID = 'G-94PHTGFJ7S';
const XOONIPS_ITEMTYPES = ['binder', 'model', 'data', 'stimulus', 'tool', 'presentation', 'paper', 'book', 'url'];
const PICO_MODULES = ['manual_ja', 'primface'];

// Vite's BASE_URL always carries a trailing slash ('/' when the app is served
// from the document root). Strip it so it can be concatenated the same way
// CRA's Config.BASE_URL was.
const BASE_URL = import.meta.env.BASE_URL.replace(/\/$/, '');

export type MultiLang = 'en' | 'ja';

const Config = {
    SITE_TITLE,
    SITE_SLOGAN,
    GOOGLE_ANALYTICS_TRACKING_ID,
    XOONIPS_ITEMTYPES,
    PICO_MODULES,
    BASE_URL,
};

export default Config;
